import React from "react";
import { ShieldCheck, Clock, Wrench, ChevronRight } from "lucide-react";
import aboutImg from "../assets/hero-removebg-preview.png";
import { triggerBookingPopup } from "../components/Header";

const About = () => {
  return (
    <section className="py-24 bg-[#F9FAFB] overflow-hidden">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* LEFT */}
          <div className="relative w-full lg:w-1/2 flex justify-center">
            {/* Rotating Ring */}
            <div className="absolute inset-0 border border-dashed border-[#FF6B00] rounded-full animate-[spin_20s_linear_infinite] scale-110 hidden md:block opacity-60" />

            {/* Blob Shape */}
            <div className="relative z-10 bg-gradient-to-b from-[#eef4ff] to-white rounded-[60%_40%_70%_30%/40%_50%_60%_40%] p-8 w-full max-w-md shadow-2xl">
              <img
                src={aboutImg}
                alt="Repair Service"
                className="w-full h-auto drop-shadow-3xl transform hover:scale-105 transition duration-500"
              />
            </div>

            {/* Floating Card */}
            <div className="verified-badge absolute top-10 left-0 bg-white shadow-xl rounded-2xl p-4 flex items-center gap-3 animate-bounce-slow z-20 border border-slate-100">
              <div className="h-10 w-10 bg-green-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold">✓</span>
              </div>
              <p className="text-sm font-bold text-gray-800">
                Verified Repairs
              </p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="w-full lg:w-1/2 space-y-8">
            <div className="space-y-4">
              {/* TAG */}
              <span className="text-[#FF6B00] font-black tracking-widest text-xm uppercase bg-[#fff1e8] px-3 py-1 rounded">
                About Us
              </span>

          <h2 className="text-4xl lg:text-6xl font-extrabold text-slate-900 leading-tight">
  
  Appliance Repair <br />

  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0F52BA] to-[#FF6B00]">
   & Service Near You
  </span>

</h2>

              {/* TEXT */}
              <p className="text-slate-600 text-lg leading-relaxed max-w-lg text-justify">
                Looking for a reliable appliance repair service near you? We
                provide expert repair and maintenance for all major home
                appliances including washing machines and refrigerators. Our
                certified technicians offer same-day service, affordable
                pricing, and guaranteed solutions. Whether it’s a minor issue or
                a major breakdown, we ensure fast diagnosis and professional
                repair at your doorstep.
              </p>
            </div>

            {/* BUTTON */}
           <button
  onClick={triggerBookingPopup}
  className="bg-[#FF6B00] text-white px-8 py-4 rounded-full font-bold hover:bg-[#d95b00] transition flex items-center gap-3"
>
  Book Repair Now
</button>
          </div>
        </div>
      </div>

      {/* ✅ FIXED STYLE */}
      <style>{`
        @keyframes bounce-slow {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-15px);
          }
        }

        .animate-bounce-slow {
          animation: bounce-slow 5s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default About;
